import { useEffect } from 'react'
import { UseFormGetFieldState, UseFormSetValue } from 'react-hook-form'
import { useFoundDevices } from 'src/Libs/installations/hooks/installation-configuration/storage/use-device-detector'
import { PowerMeterForm } from 'src/Libs/installations/models'
import { findPowerMeterIpAddress } from 'src/Libs/installations/utils/device-detector'

/**
 * Populates the power meter IP address field from the last completed device detector scan
 * (without triggering a new scan), so a previously assigned meter shows its known address
 * when the configuration page is loaded normally, not only right after an active scan.
 */
export const usePowerMeterLastScanIpAddress = (
  emcSerialnumber: string | null,
  powerMeterSerialNumber: string | undefined,
  setValue: UseFormSetValue<PowerMeterForm>,
  getFieldState: UseFormGetFieldState<PowerMeterForm>
): void => {
  const { data } = useFoundDevices(emcSerialnumber ?? undefined)

  useEffect(() => {
    if (getFieldState('powerMeterIpAddress').isDirty) return

    const ipAddress = findPowerMeterIpAddress(data?.devices, powerMeterSerialNumber)
    if (ipAddress) {
      setValue('powerMeterIpAddress', ipAddress)
    }
  }, [data, powerMeterSerialNumber, setValue, getFieldState])
}
